import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import WIDGET_DEFINITIONS, { getNestedValue } from './widgetDefinitions';

const formatValue = (value, type) => {
  if (value == null || value === '') return '--';
  if (type === 'date') {
    try {
      const d = new Date(value);
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return String(value); }
  }
  if (typeof value === 'number') return value.toLocaleString();
  return String(value);
};

const DeliveryWidgetCard = ({ widgetId, delivery, isEditMode, accentColor }) => {
  const definition = WIDGET_DEFINITIONS.find(w => w.id === widgetId);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: widgetId, disabled: !isEditMode });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  if (!definition) return null;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`so-widget-card ${isDragging ? 'so-widget-dragging' : ''}`}
    >
      <div className="so-widget-header" style={accentColor ? { background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}cc 100%)` } : undefined}>
        {isEditMode && (
          <span className="so-widget-grip" {...attributes} {...listeners}>
            <FontAwesomeIcon icon={faGripVertical} />
          </span>
        )}
        <FontAwesomeIcon icon={definition.icon} className="so-widget-icon" />
        <span className="so-widget-title">{definition.label}</span>
      </div>
      <div className="so-widget-body">
        {definition.fields.map(field => {
          const val = field.nested
            ? getNestedValue(delivery, field.key)
            : delivery?.[field.key];
          return (
            <div key={field.key} className="so-widget-field">
              <span className="so-widget-field-label">{field.label}</span>
              <span className="so-widget-field-value">{formatValue(val, field.type)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeliveryWidgetCard;
